import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  border: theme.borders.highlighted,
  borderRadius: theme.borderRadius.radius.custom,
  background: theme.palette.custom.white,
  margin: "21px 0px",
}));
export const StyledHeaderActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "13px",
  flexWrap: "wrap",
}));
export const StyledRouteDetails = styled(Box)(() => ({
  display: "flex",
  gap: "4px",
}));
export const StyledFlightInfoCard = styled(Box)(({ theme }) => ({
  margin: "8px",
  backgroundColor: theme.palette.custom.rowBg,
  padding: "9px 17px",
  display: "flex",
  gap: "10px",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
}));
export const StyledLocationText = styled(Box)(() => ({
  display: "flex",
  gap: "17px",
  flexDirection: "column",
}));
export const ShipmentIconBox = styled(Box)(({ theme }) => ({
  width: "26px",
  height: "26px",
  backgroundColor: theme.palette.custom.rowBg,
  borderRadius: theme.borderRadius.radius.small,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const StyledTypographyID = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.mini.fontSize,
}));
export const StyledTypographyDeliver = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.mini.fontSize,
  color: theme.palette.custom.orderCards,
  fontWeight: theme.typography.fontWeight.semiBold,
  marginBottom: "12px",
}));
export const StyledTypographyText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.tiny.fontSize,
  color: theme.palette.custom.lockerValueColor,
  fontWeight: theme.typography.fontWeight.bold,
}));
export const StyledTypographyAddress = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.tiny.fontSize,
  color: theme.palette.custom.lockerValueColor,
}));
export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.micro.fontSize,
  color: theme.palette.custom.danger,
  textDecoration: "underLine",
}));
export const StyledBoxDeliver = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "17px 24px",
  flexWrap: "wrap",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    gap: "15px",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
  },
}));
export const StyledBoxFlex = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "15px",
}));
export const ShipmentContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "10px",
  alignItems: "center",
  flexWrap: "wrap",
  marginBottom: "8px",
  [theme.breakpoints.down("lg")]: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
}));
